import { HStack, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { ChevronLeftIcon, CloseIcon } from '#features/ui';
import { IconButton } from '#features/ui/components/IconButton';
import type { MobileScreen } from '../../model/mobileNavigation';

type Props = {
  screen: MobileScreen;
  title: string;
  previousStep: boolean;
  backToPost?: boolean;
  back: () => void;
  cancel: () => void;
};

export const MobileScreenHeader = ({
  screen,
  title,
  previousStep,
  backToPost,
  back,
  cancel,
}: Props) => {
  const { t } = useLingui();
  const isTask = screen.kind === 'task';
  const hasBack = ['detail', 'settings', 'task'].includes(screen.kind);
  return (
    <HStack display={{ base: 'flex', lg: 'none' }} gap={2} flex="1" minW={0} data-mobile-header>
      {hasBack && (
        <IconButton
          variant="ghost"
          minW="44px"
          minH="44px"
          flexShrink={0}
          aria-label={
            isTask && !previousStep
              ? t`Cancel`
              : backToPost
                ? t`Back to your post`
                : screen.kind === 'settings'
                  ? t`Back to settings`
                  : t`Back`
          }
          onClick={back}
        >
          {isTask && !previousStep ? <CloseIcon /> : <ChevronLeftIcon />}
        </IconButton>
      )}
      <Text as="h1" textStyle="subtitle" truncate minW={0} title={title}>
        {title}
      </Text>
      {previousStep && (
        <IconButton
          variant="ghost"
          minW="44px"
          minH="44px"
          flexShrink={0}
          ml="auto"
          aria-label={t`Cancel`}
          onClick={cancel}
        >
          <CloseIcon />
        </IconButton>
      )}
    </HStack>
  );
};
